import { render } from "./AnnotationsInspectorView.vue?vue&type=template&id=4b9877cf"
import script from "./AnnotationsInspectorView.vue?vue&type=script&lang=js"
export * from "./AnnotationsInspectorView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__